/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} End_Tolerance_HelpInputs */

const en_end_tolerance_help = /** @type {(inputs: End_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolerance for end points in seconds`)
};

const fr_end_tolerance_help = /** @type {(inputs: End_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolérance pour les points de fin en secondes`)
};

const de_end_tolerance_help = /** @type {(inputs: End_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toleranz für Endpunkte in Sekunden`)
};

const it_end_tolerance_help = /** @type {(inputs: End_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolleranza per i punti finali in secondi`)
};

const ru_end_tolerance_help = /** @type {(inputs: End_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Допустимое отклонение для конечных точек в секундах`)
};

const es_end_tolerance_help = /** @type {(inputs: End_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolerancia para puntos finales en segundos`)
};

const zh_cn2_end_tolerance_help = /** @type {(inputs: End_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`终点容差（秒）`)
};

const ja_end_tolerance_help = /** @type {(inputs: End_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エンドポイントの許容範囲（秒単位）`)
};

const hi_end_tolerance_help = /** @type {(inputs: End_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम बिंदुओं के लिए सहनशीलता (सेकंड में)`)
};

const pt_pt2_end_tolerance_help = /** @type {(inputs: End_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolerância para pontos finais em segundos`)
};

/**
* | output |
* | --- |
* | "Tolerance for end points in seconds" |
*
* @param {End_Tolerance_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const end_tolerance_help = /** @type {((inputs?: End_Tolerance_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<End_Tolerance_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_end_tolerance_help(inputs)
	if (locale === "de") return de_end_tolerance_help(inputs)
	if (locale === "it") return it_end_tolerance_help(inputs)
	if (locale === "ru") return ru_end_tolerance_help(inputs)
	if (locale === "es") return es_end_tolerance_help(inputs)
	if (locale === "zh-CN") return zh_cn2_end_tolerance_help(inputs)
	if (locale === "ja") return ja_end_tolerance_help(inputs)
	if (locale === "hi") return hi_end_tolerance_help(inputs)
	if (locale === "pt-PT") return pt_pt2_end_tolerance_help(inputs)
	return en_end_tolerance_help(inputs)
});